"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * @typedef {Object} LoggerConfig
 * @property {string} [level=process.env.WEBEX_LOG_LEVEL] - Maximum log level that
 * should be printed to the console. One of
 * silent|error|warn|log|info|debug|trace
 * @property {number} [historyLength=1000] - Maximum number of entries to store in the log buffer.
 * @example
 * {
 *   level: process.env.WEBEX_LOG_LEVEL,
 *   historyLength: 1000
 * }
 */
var _default = {
  logger: {
    level: process.env.WEBEX_LOG_LEVEL,
    historyLength: 1000
  }
};
exports.default = _default;
//# sourceMappingURL=config.js.map
